module.exports = __webpack_public_path__ + "img/award-fill.d198e406.svg";